export const CARD_CATEGORY = {
  ALL: "all",
  VISIT_CARD: "visit_card",
  LEAD_CARD: "lead_card",
};

export const CARD_CATEGORY_OPTIONS = [
  { label: "全部", value: CARD_CATEGORY.ALL },
  { label: "名片", value: CARD_CATEGORY.VISIT_CARD },
  { label: "留资卡", value: CARD_CATEGORY.LEAD_CARD },
];

export const XIAOHS_VISIT_CARD_TYPE_MAP = {
  1: "微信",
  2: "钉钉",
  3: "电话",
  4: "企微",
  5: "留资卡",
};

const CATEGORY_NAME_MAP = {
  [CARD_CATEGORY.VISIT_CARD]: "名片",
  [CARD_CATEGORY.LEAD_CARD]: "留资卡",
};

function normalizeString(value) {
  if (value === undefined || value === null) {
    return "";
  }
  return `${value}`.trim();
}

function buildCardKey(category, id) {
  return `${category || "card"}_${id || ""}`;
}

export function getCardSearchText(cardItem = {}) {
  return [cardItem.name, cardItem.title, cardItem.sub_title]
    .map(normalizeString)
    .filter(Boolean)
    .join(" ")
    .trim();
}

export function normalizeAccountCardList(respData = {}, platType) {
  switch (String(platType)) {
    case "2":
      return normalizeXiaohsCardList(respData);
    default:
      return [];
  }
}

export function normalizeXiaohsCardList(respData = {}) {
  const visitCardList = respData.visit_card_list || respData.visitcard_list || [];
  const leadCardList = respData.lead_card_list || respData.leadcard_list || [];

  const visitCards = visitCardList.map(normalizeXiaohsVisitCard);
  const leadCards = leadCardList.map(normalizeXiaohsLeadCard);

  return [...visitCards, ...leadCards];
}

export function normalizeXiaohsVisitCard(item = {}) {
  const content = item.content || {};
  const cardType = content.ext?.social_card_ext?.card_type || item.card_type;
  const cardTypeName = XIAOHS_VISIT_CARD_TYPE_MAP[cardType] || "名片";
  const image = content.image || item.image || item.cover_img || "";
  const title = content.title || item.title || "";
  const name = content.name || item.name || title || "未命名名片";
  const subTitle = title;

  return {
    ...item,
    id: item.id,
    record_id: item.id,
    card_key: buildCardKey(CARD_CATEGORY.VISIT_CARD, item.id),
    card_id: content.id || item.card_id,
    plat_type: 2,
    card_category: CARD_CATEGORY.VISIT_CARD,
    card_category_name: CATEGORY_NAME_MAP[CARD_CATEGORY.VISIT_CARD],
    card_type: cardType,
    card_type_name: cardTypeName,
    name,
    title,
    image,
    cover_img: image,
    sub_title: subTitle,
    memo: item.memo || `小红书${cardTypeName}名片`,
    sub_type_str: `${cardTypeName}名片`,
    search_text: getCardSearchText({ name, title, sub_title: subTitle }),
    content,
    raw: item,
  };
}

export function normalizeXiaohsLeadCard(item = {}) {
  const content = item.content || {};
  const image = content.image || item.image || item.cover_img || "";
  const title = content.title || item.title || "未命名留资卡";
  const name = content.name || item.name || title;
  const subTitle = title;

  return {
    ...item,
    id: item.id,
    record_id: item.id,
    card_key: buildCardKey(CARD_CATEGORY.LEAD_CARD, item.id),
    card_id: content.id || item.card_id,
    plat_type: 2,
    card_category: CARD_CATEGORY.LEAD_CARD,
    card_category_name: CATEGORY_NAME_MAP[CARD_CATEGORY.LEAD_CARD],
    card_type: 5,
    card_type_name: "留资卡",
    name,
    title,
    image,
    cover_img: image,
    sub_title: subTitle,
    memo: item.memo || "小红书留资卡",
    sub_type_str: "留资卡",
    search_text: getCardSearchText({ name, title, sub_title: subTitle }),
    content,
    raw: item,
  };
}

export function getCardCategoryOptions(list = []) {
  const categorySet = new Set(list.map((item) => item.card_category).filter(Boolean));
  const options = CARD_CATEGORY_OPTIONS.filter((item) => {
    return item.value === CARD_CATEGORY.ALL || categorySet.has(item.value);
  });
  return options.length > 0 ? options : [CARD_CATEGORY_OPTIONS[0]];
}

export function filterCardList(list = [], { category = CARD_CATEGORY.ALL, keyword = "" } = {}) {
  const normalizedKeyword = normalizeString(keyword).toLowerCase();

  return list.filter((item) => {
    const categoryMatched = category === CARD_CATEGORY.ALL || item.card_category === category;
    if (!categoryMatched) {
      return false;
    }

    if (!normalizedKeyword) {
      return true;
    }

    const searchText = (item.search_text || getCardSearchText(item)).toLowerCase();
    return searchText.includes(normalizedKeyword);
  });
}
